import { useApi } from './useApi';

export const useManagerCommentsApi = ({ id, entity }) => {
  const {request} = useApi();

  return (comment) => request('post', `/${entity}/${id}/add-comment`, { comment });
}